import React, { PropTypes } from 'react';

export default class UnreadCount extends React.Component {
  static propTypes = {
    thread: PropTypes.object.isRequired,
  };

  render() {
    const { message } = this.props.thread;
    const unread = message.index - message.lastReadIndex;
    if (unread > 0) {
      return <div className="floating ui red label">{unread}</div>;
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/messaging/components/UnreadCount.js